import  { useEffect,useState} from "react";

const MedEngageSummit2223 = () => {
  const videoId = "hPeWCY4lLaQ"; // Correct video ID
  const videoLink = `https://youtu.be/${videoId}`;
  useEffect(() => {
      window.scrollTo(0, 0);
    }, []);
        useEffect(() => {
                        document.title = "Summit 2023 - MedEngage";
                      }, []);
                        const [loading, setLoading] = useState(true);

                        // ✅ useEffect instead of React.useEffect
                        useEffect(() => {
                          const timer = setTimeout(() => {
                            setLoading(false);
                          }, 300); // loader disappears after 2s

                          return () => clearTimeout(timer);
                        }, []);
  
  
  
  return (
    <>
      {loading && (
        <div
          className="fixed-top w-100 h-100 d-flex justify-content-center align-items-center bg-dark bg-opacity-50"
          style={{ zIndex: 9999 }}
        >
          <div className="custom-spinner"></div>
        </div>
      )}

      <section className="ul-about video-section-spacing">
        <div className="d-flex flex-column justify-content-center align-items-center">
          {/* Video Card */}
          <div className="summit-card">
            <div className="ratio ratio-16x9">
              <iframe
                src={`https://www.youtube.com/embed/${videoId}`}
                title="Scholarship Summit Video"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              ></iframe>
            </div>

            {/* Event Info */}
            <div className="card-body text-center p-4">
              <h2 className="text-title ul-section-title mb-3">
                The Fourth Edition of MEDENGAGE Scholarship Summit 2022-23
              </h2>

              <div className="d-flex justify-content-center gap-4 mb-3">
                <span>
                  <i className="fa fa-calendar me-2"></i> Sunday, 26 March 2023
                </span>
                <span>
                  <i className="fa fa-clock-o me-2"></i> 6 PM IST
                </span>
                <span>
                  <i className="fa fa-link me-2"></i>{" "}
                  <a
                    href={videoLink}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-success"
                  >
                    Watch
                  </a>
                </span>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default MedEngageSummit2223;
